
import { Types } from "../types"
import { GetCallQueueReportByRecordNameErrorPayLoad, GetCallQueueReportByRecordNameRequestPayload, GetCallQueueReportByRecordNameSuccessPayload, GetCallQueueReportErrorPayLoad, GetCallQueueReportRequestPayload, GetCallQueueReportSuccessPayload } from "../interfaces/callQueueReport"
import { GetCallQueueReportByRecordNameError, GetCallQueueReportByRecordNameRequest, GetCallQueueReportByRecordNameSuccess, GetCallQueueReportError, GetCallQueueReportRequest, GetCallQueueReportSuccess, getReportActivityCallQueueError, getReportActivityCallQueueRequest, getReportActivityCallQueueSuccess, getReportCallQueueByDateError, getReportCallQueueByDateRequest, getReportCallQueueByDateSuccess, getWeeklyReportCallQueueError, getWeeklyReportCallQueueRequest, getWeeklyReportCallQueueSuccess } from "../types/callQueueReport/actionType"
import { getReportCallQueueByDatePayload } from "../types/callQueueReport/apiRequestType"
import { ErrorPayLoad } from "../interfaces/purchase"
import { getReportActiveCallForAllQueueError, getReportActiveCallForAllQueueRequest, getReportActiveCallForAllQueueSuccess, getReportCallQueueByDateForListQueuesError, getReportCallQueueByDateForListQueuesRequest, getReportCallQueueByDateForListQueuesSuccess } from "../types/Queues/actionsType"
import { GetReportCallQueueByDateForListQueuesPayload, GetReportCallQueueByDateForListQueuesResponse } from "../interfaces/queue"


//getCallQueueReport********************************************************************************************************
export const getCallQueueReportRequestAction = (payload: GetCallQueueReportRequestPayload): GetCallQueueReportRequest => ({
    type: Types.GET_CALL_QUEUE_REPORT_REQUEST,
    payload
})

export const getCallQueueReportSuccessAction = (payload: GetCallQueueReportSuccessPayload): GetCallQueueReportSuccess => ({
    type: Types.GET_CALL_QUEUE_REPORT_SUCCESS,
    payload
})

export const getCallQueueReportErrorAction = (payload: GetCallQueueReportErrorPayLoad): GetCallQueueReportError => ({
    type: Types.GET_CALL_QUEUE_REPORT_ERROR,
    payload
})
//getCallQueueReportByRecordName********************************************************************************************************
export const getCallQueueReportByRecordNameRequestAction = (payload: GetCallQueueReportByRecordNameRequestPayload): GetCallQueueReportByRecordNameRequest => ({
    type: Types.GET_CALL_QUEUE_BY_RECORD_NAME_REQUEST,
    payload
})

export const getCallQueueReportByRecordNameSuccessAction = (payload: GetCallQueueReportByRecordNameSuccessPayload): GetCallQueueReportByRecordNameSuccess => ({
    type: Types.GET_CALL_QUEUE_BY_RECORD_NAME_SUCCESS,
    payload
})

export const getCallQueueReportByRecordNameErrorAction = (payload: GetCallQueueReportByRecordNameErrorPayLoad): GetCallQueueReportByRecordNameError => ({
    type: Types.GET_CALL_QUEUE_BY_RECORD_NAME_ERROR,
    payload
})


export const getReportCallQueueByDateRequestAction = (payload: getReportCallQueueByDatePayload): getReportCallQueueByDateRequest => ({
    type: Types.GET_REPORT_CALL_QUEUE_BY_DATE_REQUEST,
    payload
})

export const getReportCallQueueByDateSuccessAction = (payload: any): getReportCallQueueByDateSuccess => ({
    type: Types.GET_REPORT_CALL_QUEUE_BY_DATE_SUCCESS,
    payload
})

export const getReportCallQueueByDateErrorAction = (payload: ErrorPayLoad): getReportCallQueueByDateError => ({
    type: Types.GET_REPORT_CALL_QUEUE_BY_DATE_ERROR,
    payload
})


export const getReportActivityCallQueueRequestAction = (payload: string): getReportActivityCallQueueRequest => ({
    type: Types.GET_REPORT_ACTIVITY_CALL_QUEUE_REQUEST,
    payload
})

export const getReportActivityCallQueueSuccessAction = (payload: any): getReportActivityCallQueueSuccess => ({
    type: Types.GET_REPORT_ACTIVITY_CALL_QUEUE_SUCCESS,
    payload
})

export const getReportActivityCallQueueErrorAction = (payload: ErrorPayLoad): getReportActivityCallQueueError => ({
    type: Types.GET_REPORT_ACTIVITY_CALL_QUEUE_ERROR,
    payload
})


export const getWeeklyReportCallQueueRequestAction = (payload: string): getWeeklyReportCallQueueRequest => ({
    type: Types.GET_WEEKLY_REPORT_CALL_QUEUE_REQUEST,
    payload
})

export const getWeeklyReportCallQueueSuccessAction = (payload: any): getWeeklyReportCallQueueSuccess => ({
    type: Types.GET_WEEKLY_REPORT_CALL_QUEUE_SUCCESS,
    payload
})

export const getWeeklyReportCallQueueErrorAction = (payload: ErrorPayLoad): getWeeklyReportCallQueueError => ({
    type: Types.GET_WEEKLY_REPORT_CALL_QUEUE_ERROR,
    payload
})



export const getReportActiveCallForAllQueueRequestAction = (payload: string[]): getReportActiveCallForAllQueueRequest => ({
    type: Types.GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_REQUEST,
    payload
})

export const getReportActiveCallForAllQueueSuccessAction = (payload: any): getReportActiveCallForAllQueueSuccess => ({
    type: Types.GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_SUCCESS,
    payload
})

export const getReportActiveCallForAllQueueErrorAction = (payload: ErrorPayLoad): getReportActiveCallForAllQueueError => ({
    type: Types.GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_ERROR,
    payload
})


export const getReportCallQueueByDateForListQueuesRequestAction = (payload: GetReportCallQueueByDateForListQueuesPayload): getReportCallQueueByDateForListQueuesRequest => ({
    type: Types.GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_REQUEST,
    payload
})

export const getReportCallQueueByDateForListQueuesSuccessAction = (payload: GetReportCallQueueByDateForListQueuesResponse): getReportCallQueueByDateForListQueuesSuccess => ({
    type: Types.GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_SUCCESS,
    payload
})

export const getReportCallQueueByDateForListQueuesErrorAction = (payload: ErrorPayLoad): getReportCallQueueByDateForListQueuesError => ({
    type: Types.GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_ERROR,
    payload
})